export const setFilterText = (filterText) => ({type: "SET_FILTER_TEXT", filterText: filterText});

export const setFilterColor = (filterColor) => ({type: "SET_FILTER_COLOR", filterColor: filterColor});

